<template>
	<o-select
		v-if="setup.dataLoaded"
		v-model="setup.missionPlaceId"
		v-bind="$attrs"
		:label="label"
		:options="setup.options"
		:searchable="setup.options.length > 10"
		track-key="id"
		value-key="id"
		display-key="name">
		<template #option="{ item, markedSearch }">
			<div class="list__option">
				<div><strong v-html="markedSearch(item.name)"/></div>
				<div>{{ item.address }}</div>
				<div>{{ item.postalCode }} {{ item.city }}</div>
			</div>
		</template>
	</o-select>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedMissionPlaceSelectEmits, SharedMissionPlaceSelectProps } from './SharedMissionPlaceSelectSetup';
import SharedMissionPlaceSelectSetup from './SharedMissionPlaceSelectSetup';
const emits = defineEmits<SharedMissionPlaceSelectEmits>() as SharedMissionPlaceSelectEmits;
const props = withDefaults(defineProps<SharedMissionPlaceSelectProps>(), SharedMissionPlaceSelectSetup.defaultProps);
const setup = new SharedMissionPlaceSelectSetup(props, emits);
// #endregion
</script>
